import React, { createContext } from 'react';

import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

import { SystemManagement    } from './components/SystemManagement/SystemManagement';
import { ProkeyStatsPanel    } from './components/ProkeyStatsPanel/ProkeyStatsPanel';
import { SystemResourcePanel } from './components/SystemResourcePanel/SystemResourcePanel';

//-----------------------------------------------------------------
export function ServerPanel() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      height  : '100%' ,
    },
    container_01: {
      display : 'flex' ,
      gap     : '1rem' ,
      height  : '25rem' ,
    }
  }

  const CONTAINER = {
    sx : _styles.container,
  }
  const CONTAINER_01 = {
    sx : _styles.container_01,
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER } >
        <Box { ...CONTAINER_01 } >
          <SystemManagement />
          <ProkeyStatsPanel />
        </Box>
        <SystemResourcePanel />
      </Box>
    );
  }

  //#endregion

  return display();
}